import FormField from "../form-field";

export default class TextField extends FormField {
	constructor(props) {
		super(props);
		this.init();
	}

	init() {
		if (!this.$root) {
			throw new Error('TextField: Root element is not defined!');
		}

		this.$input = this.$root.querySelector('input[type="text"], input[type="email"], textarea');

		if (!this.$input) {
			throw new Error('TextField: Input element is not defined!');
		}

		this.name = this.name || this.$input.name;

		super.init();
	}

	addEventListeners() {
		this.$input.addEventListener('input', this.handleInput.bind(this));

		if (this.required) {
			this.$input.addEventListener('blur', this.handleBlur.bind(this));
		}
	}

	handleInput(e) {
		this.setValue(e.target.value);
		if (this.required) {
			this.validateSoft();
		}
	}

	handleBlur(e) {
		this.validateStrict();
	}

	validate() {
		if (this.pattern) {
			if (Array.isArray(this.pattern)) {
				this.isValid = (this.value !== null) && this.pattern.every((pattern) => pattern.test(this.value));
			} else {
				this.isValid = (this.value !== null) && this.pattern.test(this.value);
			}
		} else {
			this.isValid = (this.value !== null) && (this.value.length > 0);
		}
	}

	setValue(value, withInput = false) {
		value = value.trim();
		super.setValue(value)
	}

	getData() {
		return { [this.name]: this.value };
	}

	refreshInputValue() {
		if (!this.$input) return;

		this.$input.value = this.value;
		this.$input.dispatchEvent(new Event('input'));
	}

	setInitialState() {
		this.setValue('');
		this.refreshInputValue();
	}
}